import React from 'react';
import { ListItem } from 'material-ui/List';

export default () => <ListItem primaryText="None Found" />;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/job/TutorJobEmptyItem.js